'use client';

import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import InvestorList from './InvestorList';
import { PdpInfoDTO } from '@/types/models';
import { Modal } from '@/ui/kit/components/modal';
interface InvestmentSummaryProps {
  data: PdpInfoDTO;
}
const InvestmentSummary = ({
  data
}: InvestmentSummaryProps) => {
  const texts = {
    investorsModalTitle: 'سرمایه‌گذاران'
  };
  const items = [{
    key: 'duration',
    value: data.duration,
    title: 'مدت مشارکت',
    preValue: 'ماه',
    infoContent: null
  }, {
    key: 'numberOfInvestors',
    value: data.investors,
    title: 'تعداد سرمایه‌گذار',
    preValue: 'کاربر',
    infoContent: null
  }, {
    key: 'remainingTime',
    value: data.daysLeft,
    title: 'زمان باقی‌مانده ',
    preValue: 'روز',
    infoContent: null
  }];
  const [selectModal, setSelectModal] = useState<'investorList' | undefined>(undefined);
  return <Box sx={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    p: 'var(--spacing_xs)',
    borderRadius: 'var(--corner_radius_m)',
    border: '1px solid',
    borderColor: 'stroke.stroke2'
  }} data-sentry-element="Box" data-sentry-component="InvestmentSummary" data-sentry-source-file="InvestmentSummary.tsx">
      {items.map((item, idx) => {
      return <Box key={'investment_summary_' + item.key} sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRight: idx === 1 ? '1px solid' : '0px',
        borderLeft: idx === 1 ? '1px solid' : '0px',
        borderColor: 'stroke.stroke2',
        px: idx === 1 ? 'var(--spacing_l)' : 'unset',
        gap: 'var(--spacing_xs)'
      }}>
            <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 'var(--spacing_xxxs)'
        }}>
              <Typography variant='captionRegular__Wallfund' color={'text.text2'}>
                {item.title}{' '}
              </Typography>
            </Box>
            <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 'var(--spacing_xxxxs)'
        }}>
              <Typography variant='bodyStrong__Wallfund' color={item.key === 'numberOfInvestors' ? 'primaryBrand.text' : 'text.text'} onClick={() => {
            item.key === 'numberOfInvestors' && setSelectModal('investorList');
          }} sx={{
            cursor: item.key === 'numberOfInvestors' ? 'pointer' : 'unset'
          }}>
                {item.value}
              </Typography>
              <Typography variant='captionSmallMedium__Wallfund' color={'text.text2'}>
                {item.preValue}
              </Typography>
            </Box>
          </Box>;
    })}
      <Modal title={texts.investorsModalTitle} open={!!selectModal} onClose={() => setSelectModal(undefined)} data-sentry-element="Modal" data-sentry-source-file="InvestmentSummary.tsx">
        {selectModal === 'investorList' && data && <InvestorList data={data} onClose={() => setSelectModal(undefined)} />}
      </Modal>
    </Box>;
};
export default InvestmentSummary;